import { HttpClient } from '@angular/common/http';
import { Injectable, computed, inject, signal } from '@angular/core';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ParametroService {
  #parametrosState = signal<any>({
    parametros: [],
  });

  #precioTagState = signal<any>({
    parametro: {},
  });

  #valorEnvioTagState = signal<any>({
    parametro: {},
  });

  #cantidadCompraTagState = signal<any>({
    parametro: {},
  });

  #tarifaIvaState = signal<any>({
    parametro: {},
  });

  #incluirConceptoTagParaVehiculoState = signal<any>({
    parametro: {},
  });

  #incluirIvaConceptoEnvioState = signal<any>({
    parametro: {},
  });

  #incluirIvaConceptoCobroAdicionalState = signal<any>({
    parametro: {},
  });

  #valorMinimoRecarga = signal<any>({
    parametro: {},
  });

  #valorCobroAdicional = signal<any>({
    parametro: {},
  });

  #valorCobroAdicionalSuscripcion = signal<any>({
    parametro: {},
  });

  #tiempoExpiracionSesionPlaceToPay = signal<any>({
    parametro: {},
  });

  #faqPlaceToPayNombreComercio = signal<any>({
    parametro: {},
  });

  #faqPlaceToPayTelefonoComercio = signal<any>({
    parametro: {},
  });

  #faqPlaceToPayEmailComercio = signal<any>({
    parametro: {},
  });

  #faqPlaceToPayEmailSoporte = signal<any>({
    parametro: {},
  });

  #politicaPrivacidad = signal<any>({
    parametro: {},
  });

  #terminosCondiciones = signal<any>({
    parametro: {},
  });

  #maxVehiculosUsuario = signal<any>({
    parametro: {},
  });

  #maxVehiculosUsuarioEmpresariales = signal<any>({
    parametro: {},
  });

  #habilitarCompraTags = signal<any>({
    parametro: {},
  });

  #habilitarRealizarRecarga = signal<any>({
    parametro: {},
  });

  #habilitarVincularTarjeta = signal<any>({
    parametro: {},
  });

  #habilitarRegistrarVehiculo = signal<any>({
    parametro: {},
  });

  #validarRecaptcha = signal<any>({
    parametro: {},
  });

  #popUpData = signal<any>({
    parametro: {},
  });

  public parametros = computed(() => this.#parametrosState().parametros);

  public precioTag = computed(() => this.#precioTagState().parametro);
  public valorEnvioTag = computed(() => this.#valorEnvioTagState().parametro);
  public cantidadCompraTagState = computed(() => this.#cantidadCompraTagState().parametro);
  public tarifaIva = computed(() => this.#tarifaIvaState().parametro);
  public incluirConceptoTagParaVehiculo = computed(() => this.#incluirConceptoTagParaVehiculoState().parametro);
  public incluirIvaConceptoEnvio = computed(() => this.#incluirIvaConceptoEnvioState().parametro);
  public incluirIvaConceptoCobroAdicional = computed(() => this.#incluirIvaConceptoCobroAdicionalState().parametro);
  public valorMinimoRecarga = computed(() => this.#valorMinimoRecarga().parametro);
  public valorCobroAdicional = computed(() => this.#valorCobroAdicional().parametro);
  public valorCobroAdicionalSuscripcion = computed(() => this.#valorCobroAdicionalSuscripcion().parametro);
  public tiempoExpiracionSesionPlaceToPay = computed(() => this.#tiempoExpiracionSesionPlaceToPay().parametro);
  public faqPlaceToPayNombreComercio = computed(() => this.#faqPlaceToPayNombreComercio().parametro);
  public faqPlaceToPayTelefonoComercio = computed(() => this.#faqPlaceToPayTelefonoComercio().parametro);
  public faqPlaceToPayEmailComercio = computed(() => this.#faqPlaceToPayEmailComercio().parametro);
  public faqPlaceToPayEmailSoporte = computed(() => this.#faqPlaceToPayEmailSoporte().parametro);
  public politicaPrivacidad = computed(() => this.#politicaPrivacidad().parametro);
  public terminosCondiciones = computed(() => this.#terminosCondiciones().parametro);
  public maxVehiculosUsuario = computed(() => this.#maxVehiculosUsuario().parametro);
  public maxVehiculosUsuarioEmpresariales = computed(() => this.#maxVehiculosUsuarioEmpresariales().parametro);
  public habilitarCompraTags = computed(() => this.#habilitarCompraTags().parametro);
  public habilitarRealizarRecarga = computed(() => this.#habilitarRealizarRecarga().parametro);
  public habilitarVincularTarjeta = computed(() => this.#habilitarVincularTarjeta().parametro);
  public habilitarRegistrarVehiculo = computed(() => this.#habilitarRegistrarVehiculo().parametro);
  public validarRecaptchaData = computed(() => this.#validarRecaptcha().parametro);
  public popUpData = computed(() => this.#popUpData().parametro);

  http = inject(HttpClient);

  constructor() {
    //this.getParametros();
  }

  getParametros() {
    return this.http.get('/parametro/tipo-app/frontoffice').subscribe(({ data: parametros }: any) => {
      for (const parametro of parametros) {
        this.setStates(parametro);
      }
    });
  }

  getPopUpData() {
    return this.http.get('/parametro/pop-up');
  }

  async getParametroByNombre(nombre: string): Promise<any> {
    const response = this.http.get(`/parametro/by-name/${nombre}`);
    return await lastValueFrom(response);
  }

  private setStates(parametro: any) {
    switch (parametro.nombre) {
      case 'precio_tag':
        this.#precioTagState.set({
          parametro,
        });
        break;
      case 'valor_envio_tag':
        this.#valorEnvioTagState.set({
          parametro,
        });
        break;
      case 'cantidad_compra_tag':
        this.#cantidadCompraTagState.set({
          parametro,
        });
        break;
      case 'fe_tarifa_iva':
        this.#tarifaIvaState.set({
          parametro,
        });
        break;
      case 'fe_incluir_concepto_tag_para_vehiculo':
        this.#incluirConceptoTagParaVehiculoState.set({
          parametro,
        });
        break;
      case 'fe_incluir_iva_concepto_envio':
        this.#incluirIvaConceptoEnvioState.set({
          parametro,
        });
        break;
      case 'fe_incluir_iva_concepto_transaccion':
        this.#incluirIvaConceptoCobroAdicionalState.set({
          parametro,
        });
        break;
      case 'valor_minimo_recarga':
        this.#valorMinimoRecarga.set({
          parametro,
        });
        break;
      case 'valor_cobro_adicional':
        this.#valorCobroAdicional.set({
          parametro,
        });
        break;
      case 'valor_cobro_adicional_suscripcion':
        this.#valorCobroAdicionalSuscripcion.set({
          parametro,
        });
        break;
      case 'tiempo_expiracion_sesion_place_to_pay':
        this.#tiempoExpiracionSesionPlaceToPay.set({
          parametro,
        });
        break;
      case 'faq_placetopay_nombre_comercio':
        this.#faqPlaceToPayNombreComercio.set({
          parametro,
        });
        break;
      case 'faq_placetopay_telefono_comercio':
        this.#faqPlaceToPayTelefonoComercio.set({
          parametro,
        });
        break;
      case 'faq_placetopay_email_comercio':
        this.#faqPlaceToPayEmailComercio.set({
          parametro,
        });
        break;
      case 'mail_soporte_tolis':
        this.#faqPlaceToPayEmailSoporte.set({
          parametro,
        });
        break;
      case 'url_politica_privacidad':
        this.#politicaPrivacidad.set({
          parametro,
        });
        break;
      case 'url_terminos_condiciones':
        this.#terminosCondiciones.set({
          parametro,
        });
        break;
      case 'max_vehiculos_usuarios':
        this.#maxVehiculosUsuario.set({
          parametro,
        });
        break;
      case 'max_vehiculos_usuarios_empresariales':
        this.#maxVehiculosUsuarioEmpresariales.set({
          parametro,
        });
        break;
      case 'habilitar_compra_tags':
        this.#habilitarCompraTags.set({
          parametro,
        });
        break;
      case 'habilitar_realizar_recargas':
        this.#habilitarRealizarRecarga.set({
          parametro,
        });
        break;
      case 'habilitar_vincular_tarjeta':
        this.#habilitarVincularTarjeta.set({
          parametro,
        });
        break;
      case 'habilitar_registrar_vehiculo':
        this.#habilitarRegistrarVehiculo.set({
          parametro,
        });
        break;
      case 'validar_recaptcha':
        this.#validarRecaptcha.set({
          parametro,
        });
        break;
      // Agrega más casos según sea necesario
      default:
        break;
    }
  }
}
